import React from 'react';
import style from './styles/index.module.scss';

const Content: React.FC = ({ children }) => {
  return <div className={style.wrapper}>{children}</div>;
};

export default Content;
